import { useSetOpenedPopupsState } from '@/shared/atoms/opened-popups';
import { customToCurrency } from '@/shared/lib/utils/to-currency';
import { GALLERY_POPUP_NAME } from '../../popups/GalleryPopup/GalleryPopup';
import Image from '../../shared/Image';
import ConstructorButton from '../ConstructorButton';
import { useCurrentPavilionSetState } from '../atoms/current-pavilion';
import { useIsModelShownSetState } from '../atoms/is-model-shown';
import { AppPavilionData } from '../types';

type Props = {
    activeData: AppPavilionData;
};

const StandPopupInfo = ({ activeData }: Props) => {
    const { openPopup } = useSetOpenedPopupsState();
    const setCurrentPavilion = useCurrentPavilionSetState();
    const setIsModelShown = useIsModelShownSetState();
    return (
        <div className="stand-popup-info">
            <div className="text-l stand-popup-info__title">{activeData.name}</div>
            <table className="data-table stand-popup-info__table">
                <tbody>
                    <tr>
                        <td>Площадь</td>
                        <td>
                            ({activeData.space} м<sup>2</sup>)
                        </td>
                    </tr>
                    <tr>
                        <td>Цена от</td>
                        <td>
                            {typeof activeData.price === 'number'
                                ? customToCurrency(activeData.price)
                                : activeData.price}{' '}
                            ₽/м<sup>2</sup>
                        </td>
                    </tr>
                    <tr>
                        <td>Стоимость от</td>
                        <td>{customToCurrency((activeData.price as number) * activeData.space)} ₽</td>
                    </tr>
                </tbody>
            </table>
            {activeData.slug && activeData?.textSlug.at(0) !== 'i' && (
                <ConstructorButton
                    tag="span"
                    geometryVariant="wide"
                    variant="blue"
                    onClick={() => {
                        setCurrentPavilion(activeData.slug || '');
                        setIsModelShown(true);
                    }}
                >
                    Выбрать
                </ConstructorButton>
            )}
            <div className="stand-popup-info__gallery-block">
                {activeData.image?.src && (
                    <div className="stand-popup-info__gallery-block__image">
                        <Image
                            src={activeData.image.src}
                            width={activeData.image.width}
                            height={activeData.image.height}
                            alt={activeData.image.alt || ''}
                            priority
                            sizes="498px"
                            className="responsive__item"
                        />
                    </div>
                )}
                {activeData.gallery.length > 0 && activeData.slug?.startsWith('i') && (
                    <ConstructorButton
                        variant="white"
                        className="stand-popup-info__gallery-block__btn"
                        onClick={() => {
                            openPopup(GALLERY_POPUP_NAME);
                        }}
                    >
                        <span className="text-xxs">Как это выглядит</span>
                    </ConstructorButton>
                )}
            </div>
        </div>
    );
};

export default StandPopupInfo;
